class QuickProducts extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: window.BAO.MediaBreakpoints.isMd
        ? '-30px 0px -30px 0px'
        : '-80px 0px -100px 0px',
      threshold: 1,
    })

    this.observer.observe(this)
  }

  onEntry ([entry], observer) {
    this.classList.toggle(`qck-Products-active`, entry.isIntersecting)
  }
}

if (!customElements.get('quick-products')) {
  customElements.define('quick-products', QuickProducts)
}
